import { createComponent, ComponentProps } from '@/internals/utils';
export type StatValueUnitProps = ComponentProps;

const StatValueUnit = createComponent({ name: 'StatValueUnit', componentAs: 'span' });

export default StatValueUnit;
